import EditButton from './edit-button';

export default EditButton;
